document.addEventListener('DOMContentLoaded', function () {
	const header = document.getElementById('header');

	if (!header) {
		return;
	}

	const navParentsWithChildren = header.querySelectorAll('.desktop-nav-parent.has-children');
	const dropdowns = header.querySelectorAll('.desktop-dropdown');
	const dropdownOverlay = header.querySelector('.dropdown-overlay');
	const searchToggleButtons = header.querySelectorAll('[data-search-toggle]');
	const searchBackButton = header.querySelector('[data-search-back]');
	const searchDropdown = document.getElementById('search-dropdown');
	let closeTimeout;

	function openDropdown(id) {
		clearTimeout(closeTimeout);
		closeSearchDropdown();
		dropdowns.forEach(function (panel) {
			if (panel.dataset.dropdownId === id) {
				panel.classList.add('is-open');
				panel.setAttribute('aria-hidden', 'false');
			} else {
				panel.classList.remove('is-open');
				panel.setAttribute('aria-hidden', 'true');
			}
		});
		if (dropdownOverlay) {
			dropdownOverlay.classList.add('is-visible');
		}
	}

	function closeAll() {
		dropdowns.forEach(function (panel) {
			panel.classList.remove('is-open');
			panel.setAttribute('aria-hidden', 'true');
		});
		if (dropdownOverlay) {
			dropdownOverlay.classList.remove('is-visible');
		}
	}

	function openSearchDropdown() {
		if (!searchDropdown) {
			return;
		}

		closeAll();
		searchDropdown.classList.add('is-open');
		searchDropdown.setAttribute('aria-hidden', 'false');

		searchToggleButtons.forEach(function (button) {
			button.setAttribute('aria-expanded', 'true');
		});

		if (dropdownOverlay) {
			dropdownOverlay.classList.add('is-visible');
		}

		const searchInput = searchDropdown.querySelector('input[type="search"]');

		if (searchInput) {
			setTimeout(function () {
				searchInput.focus();
			}, 100);
		}
	}

	function closeSearchDropdown() {
		if (!searchDropdown) {
			return;
		}

		searchDropdown.classList.remove('is-open');
		searchDropdown.setAttribute('aria-hidden', 'true');

		searchToggleButtons.forEach(function (button) {
			button.setAttribute('aria-expanded', 'false');
		});

		if (dropdownOverlay && !header.querySelector('.desktop-dropdown.is-open')) {
			dropdownOverlay.classList.remove('is-visible');
		}
	}

	navParentsWithChildren.forEach(function (parent) {
		parent.addEventListener('mouseenter', function () {
			openDropdown(this.dataset.dropdownId);
		});
	});

	header.querySelectorAll('.desktop-nav-parent:not(.has-children)').forEach(function (parent) {
		parent.addEventListener('mouseenter', function () {
			if (parent.querySelector('[data-search-toggle]')) {
				return;
			}

			clearTimeout(closeTimeout);
			closeAll();
			closeSearchDropdown();
		});
	});

	header.addEventListener('mouseleave', function () {
		closeTimeout = setTimeout(closeAll, 100);
	});

	header.addEventListener('mouseenter', function () {
		clearTimeout(closeTimeout);
	});

	if (dropdownOverlay) {
		dropdownOverlay.addEventListener('click', function () {
			closeAll();
			closeSearchDropdown();
		});
	}

	searchToggleButtons.forEach(function (button) {
		button.addEventListener('click', function (event) {
			event.preventDefault();

			if (searchDropdown && searchDropdown.classList.contains('is-open')) {
				closeSearchDropdown();
			} else {
				openSearchDropdown();
			}
		});
	});

	if (searchBackButton) {
		searchBackButton.addEventListener('click', closeSearchDropdown);
	}

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape' && searchDropdown && searchDropdown.classList.contains('is-open')) {
			closeSearchDropdown();
		}
	});

	dropdowns.forEach(function (panel) {
		panel.addEventListener('mouseenter', function () {
			clearTimeout(closeTimeout);
		});

		panel.addEventListener('mouseleave', function (event) {
			if (dropdownOverlay && dropdownOverlay.contains(event.relatedTarget)) {
				closeTimeout = setTimeout(closeAll, 500);
			}
		});
	});

	// Mobile nav
	var hamburgerWrap = header.querySelector('.hamburger-wrap');
	var hamburgerBtn = header.querySelector('.hamburger');
	var mobileNav = header.querySelector('.mobile-nav');
	var mobileNavParents = header.querySelector('.mobile-nav-parents');
	var parentLinksWithChildren = header.querySelectorAll('.mobile-nav-link.has-children');
	var childPanels = header.querySelectorAll('.mobile-nav-children');
	var backButtons = header.querySelectorAll('.mobile-nav-back');
	var desktopNavBreakpoint = 1180;
	var resizeCloseThreshold = 50;
	var previousWindowWidth = window.innerWidth;
	var resizeTimeout;

	if (hamburgerWrap && mobileNav) {
		function closeMobileNav() {
			mobileNav.classList.remove('is-open');
			hamburgerWrap.classList.remove('is-open');
			document.body.classList.remove('mobile-nav-open');
			mobileNav.setAttribute('aria-hidden', 'true');

			if (hamburgerBtn) {
				hamburgerBtn.setAttribute('aria-expanded', 'false');
			}

			if (mobileNavParents) {
				mobileNavParents.classList.remove('is-hidden');
			}

			closeSearchDropdown();
			childPanels.forEach(function (panel) {
				panel.classList.remove('is-active');
			});
		}

		hamburgerWrap.addEventListener('click', function () {
			var isOpen = mobileNav.classList.toggle('is-open');
			hamburgerWrap.classList.toggle('is-open', isOpen);
			document.body.classList.toggle('mobile-nav-open', isOpen);

			if (isOpen) {
				window.scrollTo(0, 0);
			}

			if (hamburgerBtn) {
				hamburgerBtn.setAttribute('aria-expanded', isOpen);
			}

			mobileNav.setAttribute('aria-hidden', !isOpen);

			// Reset to parents view when closing
			if (!isOpen) {
				closeMobileNav();
			}
		});

		window.addEventListener('resize', function () {
			clearTimeout(resizeTimeout);

			resizeTimeout = setTimeout(function () {
				var currentWindowWidth = window.innerWidth;
				var widthDifference = Math.abs(currentWindowWidth - previousWindowWidth);

				previousWindowWidth = currentWindowWidth;

				if (widthDifference < resizeCloseThreshold) {
					return;
				}

				if (currentWindowWidth >= desktopNavBreakpoint && mobileNav.classList.contains('is-open')) {
					closeMobileNav();
				}
			}, 150);
		});

		// Drill into children
		parentLinksWithChildren.forEach(function (link) {
			link.addEventListener('click', function (e) {
				e.preventDefault();
				var navId = this.dataset.navId;
				var childPanel = header.querySelector('[data-parent-id="' + navId + '"]');

				// Parents fade out first
				mobileNavParents.classList.add('is-hidden');

				// Then children fade in after delay
				setTimeout(function () {
					if (childPanel) {
						childPanel.classList.add('is-active');
					}
				}, 150);
			});
		});

		// Back to parents
		backButtons.forEach(function (btn) {
			btn.addEventListener('click', function () {
				var activePanel = header.querySelector('.mobile-nav-children.is-active');

				// Children fade out first
				if (activePanel) {
					activePanel.classList.remove('is-active');
				}

				// Then parents fade in after delay
				setTimeout(function () {
					mobileNavParents.classList.remove('is-hidden');
				}, 150);
			});
		});
	}
});
